import FtlPersistenceService from "@/services/list-builder/FtlPersistenceService";
import PersistenceService from "@/services/list-builder/PersistenceService";
import { createListenerMiddleware, isPending } from "@reduxjs/toolkit";
import { debounce } from "lodash-es";
import { pushSave, setUpgradesOpen } from "./redux/appSlice";
import { setUpgradesOpen as ftlSetUpgradesOpen } from "./redux/ftlSlice";
import { listModified, updateListSettings } from "./redux/listSlice";
import { AppDispatch, RootState } from "./redux/store";

const listenerMiddleware = createListenerMiddleware();

export const saveList = async (state: RootState, dispatch: AppDispatch) => {
  const ftlMode = state.list.gameSystem === "ftl";
  const armyIds = ftlMode ? null : state.army.loadedArmyBooks.map((x) => x.uid);
  const saveData = ftlMode
    ? FtlPersistenceService.updateSave(state.list, state.ftl.ships)
    : PersistenceService.updateSave(state.list, state.units.units, armyIds);
  dispatch(listModified(saveData.modified));
  if (state.app.auth.loggedIn) {
    await dispatch(pushSave(saveData));
  }
};

const debounceSave = debounce(saveList, 1500);

const startAppListening = listenerMiddleware.startListening.withTypes<RootState, AppDispatch>();

startAppListening({
  predicate: (action) => {
    const isUnitsAction = action.type.startsWith("units/");
    const isFleetAction = action.type.startsWith("ftl/");
    const isLoadAction = action.type.includes("/load");
    const isPreviewAction = action.type.includes("/preview");
    const isSelectAction = action.type.includes("/select");
    const isResetAction = action.type.includes("/reset");

    const ignoreAction =
      isPending(action) ||
      action.type === setUpgradesOpen.type ||
      action.type === ftlSetUpgradesOpen.type ||
      isLoadAction ||
      isPreviewAction ||
      isSelectAction ||
      isResetAction;
    const isSaveAction = isUnitsAction || isFleetAction || action.type === updateListSettings.type;

    return !ignoreAction && isSaveAction;
  },
  effect: (action, { getState, dispatch }) => {
    const state = getState();
    debounceSave(state, dispatch);
  }
});

export default listenerMiddleware.middleware;
